
import localStorageService from "./localStorage.service";

const i18nService = {
  defaultLanguage: "tr",

  languages: [
    {
      lang: "tr",
      name: "Türkçe",
      flag: "tr"
    },
    {
      lang: "en",
      name: "English",
      flag: "us"
    }
  ],

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage(lang) {
    localStorageService.setItem("language", lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    return localStorageService.getItem("language") || this.defaultLanguage;
  }
};

export default i18nService;
